import { EnvironmentConfigModel } from './environment-config.service';

/**
 * uses customProps to add new configurations or override existing one
 */
export abstract class Environment {
  abstract readonly production: boolean;
  abstract readonly baseUrl: string;
  abstract readonly appName: string;
  abstract readonly serviceUrlList: ServiceUrlList;
  abstract readonly customProps?: any | EnvironmentConfigModel;
}
export interface UIAppsBaseURLs {
  ifta: string;
  dashboard: string;
  reporting: string;
}
export interface ServiceUrl {
  name: string;
  rootUrl: string;
}
export enum PlatformServiceName {
  BusinessAccountService = 'businessAccountService',
  PersonService = 'personService',
  VehicleService = 'vehicleService',
  UserService = 'userService',
  ReportingService = 'reportingService'
}
export enum IftaServiceName {
  FilingService = 'filingService',
  DistanceService = 'distanceService',
  IftaConstantsService = 'iftaConstantsService',
  FuelReceiptService = 'fuelReceiptService',
  TaxAccountService = 'taxAccountService',
  VehicleTaxAccountService = 'vehicleTaxAccountService'
}

export enum SupportToolsServiceName {
  DeviceApi = 'deviceApi',
  AppCat = 'appcat',
  DeviceGroupApi = 'deviceGroupApi',
  BusinessAccountApi = 'businessAccountApi',
  Ets = 'ets',
  SotiDevice = 'sotiDevice',
  Vds = 'vds',
  CustomerInfo = 'customerInfo',
  Rdc = 'rdc'
}
export interface ServiceUrlList {
  [id: string]: string;
}
